<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalShipmentClaimVisible" vm-title='Claim About Shipment' :vm-is-valid="!$v.detail.$invalid")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("claims.date")' :danger="$v.detail.date.$invalid && $v.detail.date.$model" :danger-text="$t('validation.required', { attribute: $t('claims.date') })" v-model="detail.date" v-if="!isEdit")
        b-form-group
          vm-textarea(:label="$t('claims.question')" counter="300" v-model="detail.question" :danger="$v.detail.question.$invalid && $v.detail.question.$model" :danger-text="$t('validation.required', { attribute: $t('claims.question') })" :placeholder='$t("claims.question_placeholder")' v-if="!isEdit")
        b-form-group
          vm-textarea(:label="$t('claims.answer')" counter="300" v-model="detail.answer" :danger="$v.detail.answer.$invalid && $v.detail.answer.$model" :danger-text="$t('validation.required', { attribute: $t('claims.answer') })" :placeholder='$t("claims.answer_placeholder")' v-if="isEdit")
</template>
<script>
import moment from 'moment'
import { required, maxLength } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalShipmentClaim',
  props: {
    detail: {
      type: Object
    },
    index: {
      type: Number
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    detail: {
      date: {
        required
      },
      question: {
        required,
        maxLength: maxLength(300)
      },
      answer: {
        maxLength: maxLength(300)
      }
    }
  },
  data: () => ({
  }),
  watch: {
    isModalShipmentClaimVisible (flag) {
      if (flag) {
        this.setClamSeenBy({ id: this.detail.id })
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalShipmentClaimVisible'
    ])
  },
  methods: {
    ...mapActions([
      'setModalShipmentClaimVisible',
      'addShipmentClaim',
      'editShipmentClaim',
      'setClamSeenBy'
    ]),
    saveRecord () {
      this.detail.date = moment(this.detail.date, '').format('YYYY-MM-DD')
      !this.isEdit ? this.addShipmentClaim(this.detail) : this.editShipmentClaim(this.detail)
    },
    close () {
      this.setModalShipmentClaimVisible(false)
    }
  }
}
</script>
